var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, Watch, } from "vue-property-decorator";
import EditDataElementLabel from "../../components/articleattributes/editdataelementlabel.vue";
let FlipSideUsageElement = class FlipSideUsageElement extends Vue {
    constructor() {
        super(...arguments);
        this.flipSideUsage = false;
    }
    valueChanged(e) { return e; }
    get elementKey() { return "flipSideUsage"; }
    get showInfoIcon() { return this.networkBroker.configuration.editDataConfiguration[this.elementKey].showInfoIcon; }
    created() { this.flipSideUsage = this.value; }
    onValueChanged(val, _oldVal) { this.flipSideUsage = val; }
};
__decorate([
    Prop({ required: true })
], FlipSideUsageElement.prototype, "disabled", void 0);
__decorate([
    Prop({ required: true })
], FlipSideUsageElement.prototype, "value", void 0);
__decorate([
    Inject()
], FlipSideUsageElement.prototype, "i18n", void 0);
__decorate([
    Inject()
], FlipSideUsageElement.prototype, "networkBroker", void 0);
__decorate([
    Emit()
], FlipSideUsageElement.prototype, "valueChanged", null);
__decorate([
    Watch("value")
], FlipSideUsageElement.prototype, "onValueChanged", null);
FlipSideUsageElement = __decorate([
    Component({
        components: {
            EditDataElementLabel,
        },
        name: "FlipSideUsageElement",
    })
], FlipSideUsageElement);
export default FlipSideUsageElement;
